import React from "react";
import { Box, Typography, Button, DialogContentText } from "@mui/material";

// SaleAmountAdjustmentHandler.jsx
const SaleAmountAdjustmentHandler = ({
  currentTotal,
  newTotal,
  paidAmount,
  onRefund,
  onCancel,
  colors,
}) => {
  // Calculate refund amount based on the provided totals
  const refundAmount = Math.min(currentTotal - newTotal, paidAmount - newTotal);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Ajustement du montant de la vente
      </Typography>

      <DialogContentText sx={{ mb: 2 }}>
        Cette modification entraînera un ajustement du montant total de la vente
        :
      </DialogContentText>

      <Box sx={{ mb: 3, pl: 2 }}>
        <Typography sx={{ mb: 1 }}>
          • Montant total actuel :{" "}
          {currentTotal.toLocaleString("fr-FR", {
            style: "currency",
            currency: "MAD",
          })}
        </Typography>
        <Typography sx={{ mb: 1 }}>
          • Nouveau montant total :{" "}
          {newTotal.toLocaleString("fr-FR", {
            style: "currency",
            currency: "MAD",
          })}
        </Typography>
        <Typography sx={{ mb: 1 }}>
          • Montant déjà payé :{" "}
          {paidAmount.toLocaleString("fr-FR", {
            style: "currency",
            currency: "MAD",
          })}
        </Typography>
        <Typography sx={{ fontWeight: "bold", mb: 1 }}>
          • Montant à rembourser :{" "}
          {refundAmount.toLocaleString("fr-FR", {
            style: "currency",
            currency: "MAD",
          })}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Button onClick={onCancel}>ANNULER</Button>
        <Button
          onClick={() => onRefund(refundAmount)}
          variant="contained"
          color="secondary"
        >
          PROCÉDER AU REMBOURSEMENT
        </Button>
      </Box>
    </Box>
  );
};

export default SaleAmountAdjustmentHandler;
